<template lang="html">
  <i-btn
    color="success"
    icon="mdi-check-circle"
    @click="$emit('click', $event)"
    :disabled="disabled"/>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    'i-btn': IconButton
  },
  props: {
    disabled: { type: Boolean, required: false, default: false }
  }
}
</script>

<style lang="css" scoped>
</style>
